import { render, staticRenderFns } from "./new-link.vue?vue&type=template&id=3dbe56a4&scoped=true"
import script from "./new-link.vue?vue&type=script&lang=js"
export * from "./new-link.vue?vue&type=script&lang=js"
import style0 from "./new-link.vue?vue&type=style&index=0&id=3dbe56a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbe56a4",
  null
  
)

export default component.exports